<template>
  <div class="appMain wid">
    <div class="flex t_l">
      <div class="flex-bet mar_t10 wid">
        <div class="flex-g-1 ba_f pad_20 mar_r10 bor_rad5">
          <div>
            <span class="fon_14 mar_r5">{{ $t('dashboard.todayOrders') }}</span>
            <span class="fon_20 color-green wei">{{ mainData.todayOrderNum }}</span>
          </div>
          <div class="flex-bet">
            <div class="fon_12 marb_l15 mar_t20 color90">{{ $t('dashboard.yesterdayOrders') }}{{ mainData.yesterdayOrderNum }}</div>
            <div class="fon_12 marb_l15 mar_t20 color90">{{ $t('dashboard.totalOrders') }}{{ mainData.totalOrderNum }}</div>
          </div>
        </div>
        <div class="flex-g-1 ba_f pad_20 mar_lr10 bor_rad5">
          <div>
            <span class="fon_14 mar_r5">{{ $t('dashboard.todayIncome') }}</span>
            <span class="fon_20 color_y wei">{{ mainData.todayIncome }}</span>
          </div>
          <div class="flex-bet">
            <div class="fon_12 marb_l15 mar_t20 color90">{{ $t('dashboard.yesterdayIncome') }}{{ mainData.yesterdayIncome }}</div>
            <div class="fon_12 marb_l15 mar_t20 color90">{{ $t('dashboard.totalIncome') }}{{ mainData.totalIncome }}</div>
          </div>
        </div>
        <div class="flex-g-1 ba_f pad_20 mar_lr10 bor_rad5">
          <div>
            <span class="fon_14 mar_r5">{{ $t('dashboard.waitRider') }}</span>
            <span class="fon_20 color_b wei">{{ mainData.waitRider }}</span>
          </div>
          <div class="flex-bet">
            <div class="fon_12 marb_l15 mar_t20 color90">
              <span>{{ $t('dashboard.onlineRider') }}</span>
              <el-tooltip class="item" effect="dark" :content="$t('dashboard.onlineRiderTip')" placement="bottom-start">
                <i class="el-icon-question" style="margin-left: 2px;"></i>
              </el-tooltip>
              <span>：</span>
              <span class="color-hotren">{{ mainData.waitAttestationRider }}</span>
            </div>
            <div class="fon_12 marb_l15 mar_t20 color90">{{ $t('dashboard.certifiedRider') }}{{ mainData.totalRider }}</div>
          </div>
        </div>
        <div style="min-height: 111px;" class="flex-g-1 ba_f pad_20 mar_l10 bor_rad5">
          <div>
            <span class="fon_14 mar_r5">{{ $t('dashboard.waitStore') }}</span>
            <span class="fon_20 color-673 wei">{{ 0.00 }}</span>
          </div>
          <div class="fon_12 marb_l15 mar_t20 color90">{{ $t('dashboard.partnerStore') }}{{ mainData.storeNum }}</div>
        </div>
      </div>
    </div>
    <div class="flex mar_t20">
      <div class="flex-bet wid">
        <div style="min-height: 111px;" class="flex-col flex-grow-1 ba_f pad_20 mar_r20 bor_rad5">
          <div class="flex-start flex-grow-1">
            <span class="fon_14 mar_r5">{{ $t('dashboard.pendingAccept') }}</span>
            <div class="flex-col-center flex-grow-1">
              <span class="color_b wei t_c fon_30">{{ mainData.handleNum }}</span>
            </div>
          </div>
        </div>
        <div style="min-height: 111px;" class="flex-col flex-grow-1 ba_f pad_20 mar_r20 bor_rad5">
          <div class="flex-start flex-grow-1">
            <span class="fon_14 mar_r5">{{ $t('dashboard.delivering') }}</span>
            <div class="flex-col-center flex-grow-1">
              <span class="color-green wei t_c fon_30">{{ mainData.deliveryNum }}</span>
            </div>
          </div>
        </div>
        <div style="min-height: 111px;" class="flex-col flex-grow-1 ba_f pad_20 bor_rad5">
          <div class="flex-start flex-grow-1">
            <span class="fon_14 mar_r5">{{ $t('dashboard.cancelRights') }}</span>
            <div class="flex-col-center flex-grow-1">
              <span class="color-hotren wei t_c fon_30">{{ mainData.cancelNum }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mar_t20 flex">
      <div class="wid60 ba_f outmain flex-g-1" style="height: 480px">
        <div class="indextite">
          {{ $t('dashboard.statsTitle') }}
          <span class="yb_margin lh16 fnormal color_9 mar_l10">{{ $t('dashboard.statsSub') }}</span>
        </div>
        <div ref="shujuEch" id="shujuEch" style="height: 360px; width: 100%"></div>
      </div>
      <div class="wid40 ba_f outmain mar_l20 flex-g-1" style="height: 480px">
        <div class="indextite">
          {{ $t('dashboard.riderRankTitle') }}
          <span class="yb_margin lh16 fnormal color_9 mar_l10">{{ $t('dashboard.riderRankSub') }}</span>
        </div>
        <div class="ba_f bor_rad5">
          <div class="t_l flex-bet lh30">
            <div class="fon_12 color_6" style="min-width: 260px;">
              <el-button size="mini" :class="{ buttonbg: buttonType == 1 }" @click="getRankList(1)">{{ $t('common.todayRank') }}</el-button>
              <el-button size="mini" :class="{ buttonbg: buttonType == 2 }" @click="getRankList(2)">{{ $t('common.weekRank') }}</el-button>
              <el-button size="mini" :class="{ buttonbg: buttonType == 3 }" @click="getRankList(3)">{{ $t('common.monthRank') }}</el-button>
            </div>
            <el-date-picker size="mini" style="width: 320px; transform: translateX(0px);" v-model="screenData.data" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"></el-date-picker>
          </div>
          <div class="mar_t20">
            <el-table :data="tableData2" stripe class="tablecenter">
              <el-table-column prop="userName" :label="$t('order.riderName')"></el-table-column>
              <el-table-column prop="count" :label="$t('common.orderCount')"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="mar_t20 flex">
      <div class="wid60 ba_f outmain flex-g-1" style="height: 500px">
        <div class="indextite">
          {{ $t('dashboard.storeDispatchTitle') }}
          <span class="yb_margin lh16 fnormal color_9 mar_l10">{{ $t('dashboard.storeDispatchSub') }}</span>
        </div>
        <el-table :data="tableData1" stripe class="tablecenter">
          <el-table-column prop="StoreName" :label="$t('common.merchantName')"></el-table-column>
          <el-table-column prop="count" :label="$t('common.todayOrdersCol')"></el-table-column>
          <el-table-column prop="money" :label="$t('common.payAmount')"></el-table-column>
        </el-table>
      </div>
      <div class="wid40 ba_f outmain mar_l20 flex-g-1" style="height: 500px">
        <div class="indextite">
          {{ $t('dashboard.incomeShareTitle') }}
          <span class="yb_margin lh16 fnormal color_9 mar_l10">{{ $t('dashboard.incomeShareSub') }}</span>
        </div>
        <div id="shujuEch2" style="height: 380px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import { getIndexInfo, getRankList, getOrderList } from '@/api/data.js';
export default {
  name: 'index',
  mounted() {
    this.echarts1_option.legend.data = [
      this.$t('dashboard.chartOrderCount'),
      this.$t('dashboard.chartIncome'),
    ];
    this.shujuEch();
    this.shujuEch2();
    window.addEventListener('resize', this.init);
  },
  data() {
    return {
      echarts1_option: {
        color: ['#4165D7', '#67c23a'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // 去除坐标轴上的刻度线
          axisTick: {
            show: false,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          // x轴的字体样式
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          // x轴的颜色和宽度
          axisLine: {
            lineStyle: {
              color: '#4ECB73',
              width: 2 //这里是坐标轴的宽度,可以去掉
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#DDDDDD'
            },
            show: true
          }
        },
        series: [
          {
            name: '订单数',
            type: 'bar',
            data: []
          },
          {
            name: '营业额',
            type: 'bar',
            data: []
          }
        ]
      },
      echarts1_option1: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        color: ['#4EC478', '#4165D7'],
        legend: {
          orient: 'vertical',
          right: 0,
          data: ['商户充值', '订单金额']
        },
        series: [
          {
            name: '今日营业额占比',
            type: 'pie',
            radius: ['47%', '60%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 0, name: '商户充值' },
              { value: 1, name: '订单金额' }
            ]
          }
        ]
      },
      tableData1: [],
      tableData2: [],
      screenData: {
        data: [new Date(), new Date()],
        type: 1
      },

      mainData: {}
    };
  },
  computed: {
    buttonType() {
      return this.screenData.type || 1;
    }
  },
  created() {
    this.getIndex();
    this.getRankList();
  },
  methods: {
    init() {
      let myChart = echarts.init(document.getElementById('shujuEch'));
      let myChart1 = echarts.init(document.getElementById('shujuEch2'));
      myChart.resize();
      myChart1.resize();
    },
    getIndex() {
      getIndexInfo().then((res) => {
        if (res.code == 1) {
          this.mainData = res.data;
          this.echarts1_option1.series[0].data[0].value = res.data.storeValue;
          this.echarts1_option1.series[0].data[1].value = res.data.todayIncome;
          res.data.barChart.forEach((item) => {
            this.echarts1_option.xAxis.data.push(item.hours);
            this.echarts1_option.series[0].data.push(item.count);
            this.echarts1_option.series[1].data.push(item.money);
          });
          this.shujuEch();
          this.shujuEch2();
        }
      });
    },
    // 获取骑手列表
    getRankList(type) {
      this.screenData.type = type || null;
      getRankList(this.screenData).then((res) => {
        if (res.code == 1) {
          this.tableData2 = res.data;
        }
      });
      getOrderList().then((res) => {
        if (res.code == 1) {
          this.tableData1 = res.data;
        }
      });
    },
    shujuEch() {
      let myChart = echarts.init(document.getElementById('shujuEch'));
      myChart.setOption(this.echarts1_option, true);
    },
    shujuEch2() {
      let myChart = echarts.init(document.getElementById('shujuEch2'));
      myChart.setOption(this.echarts1_option1, true);
    },
    onChangOption() {}
  }
};
</script>

<style lang="stylus" scoped>
.maxw {
  transform: translateX(20px) !important;
}
</style>